

    	
	var winWidth = 520, 
		winHeight = 350,
		winTop = (screen.height / 2) - (winHeight / 2),
		winLeft = (screen.width / 2) - (winWidth / 2),
		popupMeta = 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight;
	
	function socialShare(network, url, title) { 
		
		if (network == 'facebook') {
			window.open('http://www.facebook.com/sharer/sharer.php?u=' + url, 'sharer', popupMeta);
		} else if (network == 'twitter') {
			window.open('https://twitter.com/intent/tweet?text=' + title + '%20-%20&url=' + url, 'sharer', popupMeta);
		}
		
	}    

